import React, { useCallback, useEffect, useState } from 'react';
import { AppState, Platform } from 'react-native';

// @ts-ignore
import {
    // @ts-ignore
    checkScreenCapture,
    // @ts-ignore
    onScreenCaptureChange,
    // @ts-ignore
    startMirroringListener,
    // @ts-ignore
    stopMirroringListener
} from 'react-native-prevent-screenshot-ios-android';
import { useStore } from 'Store';

const useMirroringCheck = () => {
    const { setPlayerData } = useStore();
    const [isMirroring, setIsMirroring] = useState<boolean>(false);

    const androidMirroringListener = useCallback((event: string) => {
        if (event === 'DisplayAdded') {
            setIsMirroring(true);
        } else {
            setIsMirroring(false);
        }
    }, [setIsMirroring]);

    const getIsMirroring = async () => {
        if (Platform.OS === 'android') {
            const data = await checkScreenCapture();
            if (data === 'Mirrored') {
                setIsMirroring(true);
                return true;
            }
            setIsMirroring(false);
            return false;

        }
        if (Platform.OS === 'ios') {
            const data = await checkScreenCapture();
            if (data) {
                setIsMirroring(true);
                return true;
            }
            setIsMirroring(false);
            return false;

        }
        return false;
    };

    const onScreenCaptureChangeListener = useCallback(() => {
        getIsMirroring();
    }, [setIsMirroring, getIsMirroring]);



    const mirroringSubscription = () => {
        let listener;
        if (Platform.OS === 'android') {
            startMirroringListener(androidMirroringListener);
        }
        if (Platform.OS === 'ios') {
            listener = onScreenCaptureChange(onScreenCaptureChangeListener);

        }
        return () => {
            if (Platform.OS === 'android') {
                stopMirroringListener();
            }
            if (Platform.OS === 'ios') {
                listener?.remove?.();
            }
        };
    };

    useEffect(() => {
        const listener = mirroringSubscription();
        getIsMirroring();
        return () => {
            listener();
        };
    }, [startMirroringListener, checkScreenCapture, onScreenCaptureChange]);

    useEffect(() => {
        if (isMirroring) setPlayerData(null);
    }, [isMirroring]);

    useEffect(() => {
        const appStateListener = AppState.addEventListener('change', nextAppState => {
            if (nextAppState === 'active') {
                getIsMirroring();
            }
        });
        return () => {
            appStateListener.remove();
        };
    }, []);

    return {
        isMirroring,
        setIsMirroring,
        getIsMirroring
    };
};

export default useMirroringCheck;
